export default "__VITE_ASSET__BAhWCzqx__"